<template>
    <footer class="max-w-md pb-16 text-sm text-slate-500 sm:pb-0">
        <p>
            Developed in 
            <a href="https://code.visualstudio.com/" class="font-medium text-slate-400 hover:text-teal-300 focus-visible:text-teal-300" target="_blank" rel="noreferrer noopener" aria-label="Visual Studio Code (opens in a new tab)">
                Visual Studio Code
            </a> 
            by yours truly. Built with 
            <a href="https://vuejs.org/" class="font-medium text-slate-400 hover:text-teal-300 focus-visible:text-teal-300" target="_blank" rel="noreferrer noopener" aria-label="Next.js (opens in a new tab)">
                Vue.js
            </a> 
            and 
            <a href="https://tailwindcss.com/" class="font-medium text-slate-400 hover:text-teal-300 focus-visible:text-teal-300" target="_blank" rel="noreferrer noopener" aria-label="Tailwind CSS (opens in a new tab)">
                Tailwind CSS
            </a>
            , deployed with 
            <a href="https://pages.github.com/" class="font-medium text-slate-400 hover:text-teal-300 focus-visible:text-teal-300" target="_blank" rel="noreferrer noopener" aria-label="Vercel (opens in a new tab)">
                Github Pages
            </a>
            .
        </p>
    </footer>
</template>